import React from 'react';

import { Header } from '../BettermentForAdvisors/Header';
import { Layout } from '../InstitutionalApp/Layout';

export type ReportsTab = 'fee_statements' | 'tax_forms' | 'firm_fee_accruals';

interface Props {
  activeTab: ReportsTab;
  children: React.ReactNode;
}

export const ReportsLayout: React.FC<Props> = ({ children }) => {
  return (
    <Layout active="reports">
      <Layout.Header>
        <Header title="Reports" />
      </Layout.Header>
      <Layout.Content>{children}</Layout.Content>
    </Layout>
  );
};
